// Full-document render of the Oscar basket view: PageSkeleton (the React
// document shell) wrapping the `#basket-app` mount point.
import React from "react";

import { templates } from "@reactivated";

import { BasketApp } from "../apps/checkout/BasketApp";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.BasketDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {/* The basket app lives in the document's React tree (mounted
                client-side by BasketApp; the dependency tree is not SSR-safe).
                The #basket-app id is retained for the 60-minute redirect timer
                in apps/checkout/index.tsx. */}
            <div id="basket-app" className="basket-container">
                <BasketApp />
            </div>
        </PageSkeleton>
    );
};
